import DashboardLayout from "pages/layouts/dashboard";
import React, { useEffect, useState } from "react";
import JobCard from "./JobCard";
import { Box } from "@mui/material";
import MainTabs from "components/UI/organisms/MainTabs";
import ApplicationsLiting from "../listings/ApplicationsLiting";
import Button from "components/Button";
import useRedirect from "helpers/hooks/useRedirect";
import useJobNetwork from "store/job-network";
import { useParams, useSearchParams } from "react-router-dom";
import { APPLICATION_STATUS } from "../forms/data";
import AppliedSuccessModal from "./AppliedSuccessModal";
import { useLocalizedTranslation } from "helpers/hooks/useLocalizedTranslation";

const JobDetailPage = () => {
  const [tab, setTab] = useState(0);
  const [job, setJob] = useState(null);
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState("job");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const { navigateJobNetworks, navigateManageJobNetworks } = useRedirect();
  const { t } = useLocalizedTranslation("common");
  const { id } = useParams();
  const {
    fetchJob,
    fetchApplications,
    applyJob,
    updateApplicationStatus,
    deleteJob,
  } = useJobNetwork();
  const [appliedSuccessModalOpen, setAppliedSuccessModalOpen] = useState(false);

  const [params] = useSearchParams();
  const isPrivateView = params.get("private") === "true";

  useEffect(() => {
    if (id) fetchDetails();
  }, [id, isPrivateView]);

  useEffect(() => {
    if (!isPrivateView) return;
    if (id && loading !== "job") handleFetchApplications();
  }, [tab, id, loading === "job", page]);

  const fetchDetails = async () => {
    setLoading("job");
    const res = await fetchJob(id, isPrivateView);
    setJob(res);
    setLoading(false);
  };

  const handleFetchApplications = async () => {
    setLoading("applications");
    const filters = { page };
    const status = APPLICATION_STATUS()[+tab]?.key;
    filters["status"] = status;
    const apps = await fetchApplications(id, filters);
    setApplications(apps?.list || []);
    if (page > apps?.current_page) setPage(apps?.current_page);
    setPages(apps?.total_pages || 0);
    setLoading(false);
  };

  const handleApplyJob = async () => {
    const res = await applyJob(job?.uuid);
    if (res?.data?.success) {
      setJob((prev) => ({
        ...prev,
        application_applied: "yes",
        application_status: "pending",
      }));
      setAppliedSuccessModalOpen(true);
    }
  };

  const handleUpdateApplicationStatus = (e) => {
    const newStatus = e.target.value;
    const applicationId = e.target.name;
    updateApplicationStatus(applicationId, newStatus);
    setApplications((prev) =>
      prev.map((d) => ({
        ...d,
        status: d?.id === applicationId ? newStatus : d?.status,
      }))
    );
  };

  const handleDeleteJob = async () => {
    await deleteJob(id);
    navigateManageJobNetworks();
  };

  return (
    <DashboardLayout
      isPrivate
      hideOnSeedPlan={!loading}
      loading={loading === "job"}
      isEmpty={!job?.uuid}
      emptyMessage="Job does not exist!"
      show404OnError
    >
      <Box className="container mt-header">
        <Button
          onClick={() =>
            isPrivateView ? navigateManageJobNetworks() : navigateJobNetworks()
          }
          classes="my-4 w-100"
        >
          {t("Back")}
        </Button>
        <JobCard
          data={job}
          defaultExpanded
          manage={isPrivateView}
          onApply={handleApplyJob}
          deleteJob={handleDeleteJob}
          t={t}
        />
        {isPrivateView ? (
          <>
            <MainTabs
              current={tab}
              classes="mt-5"
              setCurrent={setTab}
              tabs={APPLICATION_STATUS().map((d) => d?.title)}
            />
            <ApplicationsLiting
              applications={applications}
              loading={loading === "applications"}
              handleUpdateApplicationStatus={handleUpdateApplicationStatus}
              page={page}
              pageCount={pages}
              setPage={setPage}
            />
          </>
        ) : null}
      </Box>
      <AppliedSuccessModal
        onClose={() => setAppliedSuccessModalOpen(false)}
        open={appliedSuccessModalOpen}
        t={t}
      />
    </DashboardLayout>
  );
};

export default JobDetailPage;
